import { useT } from "../../shared/i18n";
import { Button, UnavailableCommand } from "../../shared/ui";

export interface AdminEntryState {
  is_operator: boolean;
  can_enter: boolean;
}

/**
 * An ordinary user sees no Admin entry at all. A linked operator gets the
 * console when an Operator Session is active, and a sign-in prompt otherwise —
 * a Telegram Platform User Session grants no administrative authority.
 */
export function AdminEntry({
  state,
  onEnter,
  onSignIn,
  waiting = false,
  failed = false,
}: {
  state: AdminEntryState;
  onEnter: () => void;
  onSignIn: () => void;
  /** The system-browser sign-in is under way and the app is polling for it. */
  waiting?: boolean;
  /** The last sign-in attempt timed out or was rejected. */
  failed?: boolean;
}) {
  const t = useT();
  if (!state.is_operator) return null;
  if (state.can_enter)
    return (
      <Button variant="secondary" onClick={onEnter}>
        {t("admin.enter")}
      </Button>
    );
  return (
    <UnavailableCommand
      unavailableLabel={t("unavailable.prefix")}
      reason={
        waiting
          ? t("admin.handoffWaiting")
          : failed
            ? t("admin.handoffFailed")
            : t("admin.browserNote")
      }
      control={
        <Button variant="secondary" onClick={onSignIn}>
          {t("admin.signIn")}
        </Button>
      }
    />
  );
}
